import React from 'react';
import { useIntl } from 'react-intl';
import { getEventHubNavigationLinks } from '../../../../constants/navigation.constants';
import { useRouteParams } from '../../../../infrastructure/hooks/use-route-params';
import { Navigation } from '../../../_events/_manage-event/shared/navigation/navigation';

type EventHubsNavigationProps = {
    actions?: React.ReactNode;
};

export const EventHubsNavigation = ({ actions }: EventHubsNavigationProps): JSX.Element => {
    const intl = useIntl();
    const { accountId, eventHubId } = useRouteParams();

    const links = getEventHubNavigationLinks(accountId, eventHubId, intl);

    return (
        <div className='horizontal-row horizontal-row--with-bottom-margin event-tabs'>
            <Navigation links={links} />
            {actions && (
                <div className='horizontal-row__align-to-row-end'>
                    {actions}
                </div>
            )}
        </div>
    );
};